import { TCreator } from '../columns/useGetCreatorColumn';

export const getCreatorDisplayName = (creator: TCreator) => {
  return creator ? `${creator?.firstName ?? ''} ${creator?.lastName ?? ''}` : '';
};
